import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@tubo/ui/components/ui/tabs";
import { CleanProfilesTab } from "@client/components/data-center/cleaning/clean-profiles-tab";
import { CleanRunsTab } from "@client/components/data-center/cleaning/clean-runs-tab";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_app/data-center/cleaning/")({
  component: DataCleaningPage,
  validateSearch: (search: Record<string, unknown>) => ({
    tab: search.tab === "runs" ? "runs" : "profiles",
    profileId: typeof search.profileId === "string" && search.profileId ? search.profileId : undefined,
  }),
});

function DataCleaningPage() {
  const { t } = useTranslation("dataCenter");
  const { tab, profileId } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const setTab = (next: string) =>
    void navigate({ search: (prev) => ({ ...prev, tab: next === "runs" ? "runs" : "profiles" }), replace: true });

  return (
    <div className="flex flex-col gap-4 p-4">
      <div>
        <h1 className="text-lg font-semibold">{t("cleaning.title")}</h1>
        <p className="text-sm text-muted-foreground">
          {t("cleaning.pageDescription")}
        </p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="profiles">{t("cleaning.profiles")}</TabsTrigger>
          <TabsTrigger value="runs">{t("cleaning.runs")}</TabsTrigger>
        </TabsList>
        <TabsContent value="profiles">
          <CleanProfilesTab />
        </TabsContent>
        <TabsContent value="runs">
          <CleanRunsTab profileId={profileId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
